<template>
  <v-list
    class="p-0 border-radius-none subgroup-list"
    dense
  >
    <v-list-group
      v-model="opened"
      class="sidebar-dropdown-link"
    >
      <template #activator>
        <v-list-item-icon>
          <slot name="icon">
            <div class="nav-sublinks-expandable pl-nav-sub-dropdown relative-upper d-flex align-items-center">
              {{ title }}
            </div>
          </slot>
        </v-list-item-icon>
        <v-list-item-title>
          <b class="sidebar-link__icon-dropwdown pl-5">
            {{ subGroup.title }}
          </b>
        </v-list-item-title>
      </template>
      <v-list-item
        v-for="item in subGroup"
        :key="item.title"
        class="link-dropdown"
        link
        :to="item.to ? {
          name: item.to.name,
          query:item.to.query
        } : ''"
        style="display: flex !important; align-items: center !important"
      >
        <v-list-item-title>
          <b
            class="pl-nav-sub-items relative-upper"
          >
            {{ item.title }}
          </b>
        </v-list-item-title>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>
<script>
export default {
  props: {
    subGroup:{
      type: Array,
      required: true,
    },
    title:{
      type: String,
      required: true,
    },
  },
  data(){
    return {
      opened: false,
    }
  },
  computed:{
    expanded(){
      return this.$store.state.navbar_expanded;
    },
  },
  watch:{
    expanded(value)
    {
      if(!value){
        this.opened = false;
      }
    },
  },
}
</script>
<style lang="scss">
@import "../../../../sass/student/01-settings/_colors";
@import "../../../../sass/student/06-components/_sidebar";
.v-list-item--link:before{
  background: none;
}

.nav-sublinks-expandable {
  font-size: 0.91rem;
  font-weight: 600;
  color:#000;
}

.link-dropdown+.v-list-item+.v-list-item--link+.theme--light,.link-dropdown{
  @extend .sidebar-link;
  padding: 0 !important;
  margin: 0 !important;
  & > * , & > :not(.v-list-item__title) {
    padding: 0 !important;
    margin: 0 !important;
    background-color: inherit !important;
    & > * {
      background-color: inherit !important;
      & > * {
        background-color: inherit !important;
      }
    }
  }
    &  * {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
}

.border-radius-none {
  & > *  {
    border-radius: 0 !important;
  }
}

.relative-upper {
  position: relative;
  z-index: 9;
}

.subgroup-list {
  & .v-icon{
    @extend .relative-upper;
  }
}
</style>
